export const DEFAULT_NEW_WORKSPACE = {
  companyId: '', useCaseName: '', description: '', filePromptConfiguration: '', sqlPromptConfiguration: '', useCaseDetails: [] 
};